// src/quizData.js
export const quizQuestions = [
    {
        id: 'q1',
        questionText: "What is your organization's most pressing strategic priority right now?",
        options: [
            { text: "Improving learner engagement, retention, and course completion rates.", packageScores: { 1: 2 } },
            { text: "Upskilling our tutors to deliver higher quality, more consistent numeracy instruction.", packageScores: { 2: 1, 3: 1 } },
            { text: "Enhancing the work-readiness and employability of our learners.", packageScores: { 5: 2 } },
            { text: "Better supporting learners with diverse needs and specific learning disabilities.", packageScores: { 6: 2 } }
        ]
    },
    {
        id: 'q2',
        questionText: "Which statement best describes the primary skill gap in your teaching staff?",
        options: [
            { text: "Our staff struggles to teach complex topics like percentages and proportional reasoning.", packageScores: { 3: 2 } },
            { text: "We need to ensure our program delivery meets specific NZQA unit standards for measurement.", packageScores: { 4: 2 } },
            { text: "Our tutors need better strategies for motivating learners to take ownership of their progress.", packageScores: { 1: 2 } },
            { text: "Our learners need stronger soft skills, and our staff needs training on how to teach them.", packageScores: { 5: 1 } }
        ]
    },
    {
        id: 'q3',
        questionText: "What feedback are you getting from your teaching staff regarding their professional development needs?",
        options: [
            { text: "Tutors, especially non-specialists, lack confidence in teaching foundational maths.", packageScores: { 2: 2 } },
            { text: "They feel unequipped to handle learners with deep-seated maths anxiety or potential dyscalculia.", packageScores: { 6: 2 } },
            { text: "They need practical strategies to help learners become more organized and self-directed.", packageScores: { 1: 1 } },
            { text: "They require clear guidance on aligning teaching with specific numeracy unit standards.", packageScores: { 4: 2 } }
        ]
    },
    {
        id: 'q4',
        questionText: "What program improvement would bring the most value to your organization?",
        options: [
            { text: "Becoming known as a provider that effectively supports neurodiverse learners.", packageScores: { 6: 2 } },
            { text: "Boosting our graduates' employment rates by adding a dedicated workplace skills component.", packageScores: { 5: 2 } },
            { text: "Raising the overall quality and consistency of our numeracy instruction across all programs.", packageScores: { 2: 1, 3: 1 } },
            { text: "Seeing a measurable increase in learner engagement and self-efficacy.", packageScores: { 1: 2 } }
        ]
    },
    {
        id: 'q5',
        questionText: "If you could invest in only one area of numeracy training, which would it be?",
        options: [
            { text: "Building tutor confidence and a solid toolkit for teaching foundational number skills.", packageScores: { 2: 2 } },
            { text: "Advanced strategies for teaching fractions, decimals, and other complex concepts.", packageScores: { 3: 2 } },
            { text: "A targeted workshop on teaching measurement and statistics to meet NZQA standards.", packageScores: { 4: 2 } },
            { text: "Understanding and supporting learners with the specific neurodiversity of dyscalculia.", packageScores: { 6: 1 } }
        ]
    }
];